import { SPINE_X } from "@/common/timelineGeometry";

/**
 * The spine's stroke at a given depth. The steps are deliberately coarse —
 * a half-pixel difference is not a signal anyone can read.
 */
function spineWidth(depth: number) {
  if (depth <= 0) return 3;
  if (depth === 1) return 2;
  return 1;
}

/**
 * This row's segment of the spine, drawn edge to edge of the row including the
 * gap it carries, so consecutive rows tile into one unbroken line. Per row
 * rather than per section so the stroke can change from one row to the next.
 *
 * `dashed` is the line saying it does not really run here: an interval with
 * nothing recorded in it, or a stretch of the axis outside the range on screen.
 */
export function Spine({ depth, dashed }: { depth: number; dashed?: boolean }) {
  if (dashed) {
    return (
      <span
        aria-hidden
        className={`pointer-events-none absolute inset-y-0 border-l border-dashed ${
          depth <= 0 ? "border-primary/40" : "border-node-line"
        }`}
        style={{ left: SPINE_X - 0.5 }}
      />
    );
  }
  const width = spineWidth(depth);
  return (
    <span
      aria-hidden
      className={`pointer-events-none absolute inset-y-0 ${
        depth <= 0
          ? "bg-primary/35"
          : depth === 1
            ? "bg-node-line"
            : "bg-node-line/70"
      }`}
      style={{ left: SPINE_X - width / 2, width }}
    />
  );
}
